import { getToken } from '../utils/getToken'

import { wrapFetch } from './FetchHelper'

export const NotificationService = {
  getNotifications: (page = 1, pageSize = 10, unreadOnly = false) => {
    return wrapFetch(
      fetch(`/api/notifications?page=${page}&pageSize=${pageSize}&unreadOnly=${unreadOnly}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    ).onSuccess(json => json)
  },

  getUnreadCount: () => {
    return wrapFetch(
      fetch('/api/notifications/unread-count', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    ).onSuccess(json => json)
  },

  markAsRead: id => {
    return wrapFetch(
      fetch(`/api/notifications/${id}/read`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    )
  },

  markAllAsRead: () => {
    return wrapFetch(
      fetch('/api/notifications/read-all', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    )
  },

  delete: id => {
    return wrapFetch(
      fetch(`/api/notifications/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
    )
  },
}
